'use client'

import Link from 'next/link'
import { useChromeT } from '../../app/i18n/useChromeT'
import { usePathname } from 'next/navigation'

const footerLinkClass = 'mr-2 underline inline-flex min-h-11 items-center'

// FooterLinks component definition
const FooterSafe = () => {
  const t = useChromeT()
  const pathname = usePathname()

  const hiddenPaths = ['/chat']

  // Chat v3 has no footer either, on /chat-v3 and anything under it (Andy, 2 Nov 2026).
  const inChatV3 = pathname === '/chat-v3' || pathname?.startsWith('/chat-v3/')

  if (hiddenPaths.includes(pathname) || inChatV3) {
    return null
  }

  return (
    <div className="my-4">
      <div className="mt-5 flex justify-center items-center space-x-2 text-sm">
        <p className="text-white flex flex-wrap text-gray-300">
          <Link
            href="/termsofservice"
            prefetch={false}
            className={footerLinkClass}
          >
            {t('termsOfService')}
          </Link>
          <Link
            href="/privacypolicy"
            prefetch={false}
            className={footerLinkClass}
          >
            {t('privacyPolicy')}
          </Link>
          <Link
            href="/contentremoval"
            prefetch={false}
            className={footerLinkClass}
          >
            {t('contentremoval')}
          </Link>
          <Link
            href={`/dmcapolicy`}
            prefetch={false}
            className={footerLinkClass}
          >
            {t('dmcapolicy')}
          </Link>
          <Link href={`/refund`} prefetch={false} className={footerLinkClass}>
            {t('refundpolicy')}
          </Link>
          <Link
            href={`/contentmoderationpolicy`}
            prefetch={false}
            className={footerLinkClass}
          >
            {t('contentmoderationpolicy')}
          </Link>
          {/* /contact, not a mailto — same reasoning as the main footer. */}
          <Link href={`/contact`} prefetch={false} className={footerLinkClass}>
            support@promptchan.com
          </Link>
        </p>
      </div>
    </div>
  )
}

export default FooterSafe
